import {
  Box,
  Button,
  Divider,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { colors } from "../../../../theme/colors";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

import { FadeInContainer } from "../../Atoms";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { teal } from "@mui/material/colors";
import useToast from "../../../../hooks/context/useToast";
import { useEffect, useState } from "react";
import {
  createAddress,
  getUserAddress,
} from "../../../../services/addressService";
import useAuth from "../../../../hooks/context/useAuth";
import { CustomModal } from "../../Organisms";
import { EditCreateAddress } from "../../Organisms/MyInfoComponents/EditAddress";
import { calcFreteService } from "../../../../services/cartService";

interface Props {
  totalItens: number;
  fullPrice: number;
  nextStep: VoidFunction;
  backStep?: VoidFunction;
  btnText: string;
  showBackBTN: boolean;
  addressToOrder?: (adID: number) => void;
  selectedAddressID: number;
  selectedProducts: CartXProduct[];
  setSelectedFrete: (data: { freteType: string; value: string }) => void;
  selectedFrete: { freteType: string; value: string };
  disablePayButton: boolean;
}
interface FreteOptions {
  name: "SEDEX" | "PAC";
  error: string;
  hasError: boolean;
  price: string;
  timeDelivery: number;
}

export function DrawerCheckout({
  totalItens,
  fullPrice,
  nextStep,
  backStep,
  btnText,
  showBackBTN,
  addressToOrder,
  selectedAddressID,
  selectedProducts,
  setSelectedFrete,
  selectedFrete,
  disablePayButton,
}: Props) {
  const { BRLmoney } = useBRLmoney();
  const { isMobile, isSmalldesktop } = useBreakpoints();
  const { setOpen, setToastData } = useToast();
  const { user } = useAuth();
  const [address, setAddress] = useState<IAddress[]>();
  const [selectedAddress, setSelectedAddress] = useState<IAddress | null>();
  const [newAddressModalOpen, setNewAddressModalOpen] = useState(false);
  const [loadingNewAd, setLoadingNewAd] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [freteInfo, setFreteInfo] = useState<FreteOptions[]>([]);
  const [loadingFretes, setLoadingFretes] = useState(false);

  const calcFrete = async (postalCode: string) => {
    setLoadingFretes(true);
    try {
      const response = await calcFreteService({
        fromCep: "01153000",
        toCep: postalCode,
        products: selectedProducts?.map((prd) => ({
          height: prd?.product?.height,
          length: prd?.product?.length,
          weight: prd?.product?.weight,
          width: prd?.product?.width,
          id: prd?.product?.id,
          quantity: prd?.quantity,
        })),
      });
      setFreteInfo(response);
    } catch {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 3000,
        type: "error",
        message: "Ocorreu um erro ao calcular o frete, tente novamente.",
      });
      setOpen(true);
    } finally {
      setLoadingFretes(false);
    }
  };

  const myAddress = async () => {
    setLoadingAddress(true);
    try {
      const myAddress = await getUserAddress(user?.user?.id);
      setAddress(myAddress);
      if (myAddress?.length === 1) {
        setSelectedAddress(myAddress[0]);
        addressToOrder(myAddress[0].id);
      }
    } catch (err) {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 3000,
        type: "error",
        message: "Ocorreu um erro ao buscar seus endereços, tente novamente.",
      });
      setOpen(true);
    } finally {
      setLoadingAddress(false);
    }
  };

  const createEditAddress = async (val: EditCreateAddress) => {
    setLoadingNewAd(true);
    try {
      await createAddress(val);
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "success",
        message: "Endereço criado com sucesso.",
      });
      setOpen(true);
      await myAddress();
    } catch (err) {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "error",
        message: "Ocorreu um erro ao criar o endereço, tente novamente.",
      });
      setOpen(true);
    } finally {
      setNewAddressModalOpen(false);
      setLoadingNewAd(false);
    }
  };

  useEffect(() => {
    if (user?.user?.id) {
      myAddress();
    }
    // eslint-disable-next-line
  }, [user?.user?.id]);

  const handleChange = (e: any) => {
    if (e?.target?.value) {
      const findAd = address?.find((ad) => ad?.id === e?.target?.value);
      setSelectedAddress(findAd);
      addressToOrder(findAd.id);
    }
  };

  const handleChangeFrete = (event: React.ChangeEvent<HTMLInputElement>) => {
    const findFrete = freteInfo.find(
      (frete) => frete.name === (event.target as HTMLInputElement).value
    );
    setSelectedFrete({ freteType: findFrete?.name, value: findFrete?.price });
  };

  useEffect(() => {
    const findAd = address?.find((ad) => ad?.id === selectedAddressID);
    if (findAd) {
      setSelectedAddress(findAd);
      calcFrete(findAd.postalCode);
    }
    // eslint-disable-next-line
  }, [selectedAddressID, address, selectedProducts]);

  return (
    totalItens > 0 && (
      <FadeInContainer>
        <Box
          width={"100%"}
          sx={{
            borderRadius: "15px",
            mt: 1,
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {loadingAddress ? (
            <CircularProgress />
          ) : (
            <Box p={2}>
              {!Boolean(selectedAddress) ? (
                <Typography fontSize={14} color={colors.purple[500]}>
                  Selecione o endereço
                </Typography>
              ) : (
                <Typography fontSize={14} color={colors.purple[500]}>
                  Endereço selecionado
                </Typography>
              )}
              {address?.length === 0 ? (
                <Button onClick={() => setNewAddressModalOpen(true)}>
                  + Novo endereço
                </Button>
              ) : (
                <Select
                  sx={{ mb: 2, maxWidth: 250, minWidth: 250 }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedAddress?.id}
                  defaultChecked
                  defaultValue={selectedAddressID}
                  onChange={handleChange}
                  placeholder="Selecione"
                >
                  <MenuItem value={0}>Selecione</MenuItem>
                  {address?.map((ad) => (
                    <MenuItem value={ad?.id}>
                      {ad?.address} {ad?.adressNumber} {ad?.addressComplement} /{" "}
                      {ad?.city} / {ad?.country}
                    </MenuItem>
                  ))}
                </Select>
              )}

              <Box>
                {selectedAddress && (
                  <>
                    <Typography>
                      {selectedAddress?.address + ", "}
                      {selectedAddress?.adressNumber}
                    </Typography>
                    {selectedAddress?.addressComplement && (
                      <Typography>
                        Complemento: {selectedAddress?.addressComplement}
                      </Typography>
                    )}
                    <Typography>
                      Bairro {selectedAddress?.neighborhood}
                    </Typography>
                    <Typography>
                      {selectedAddress?.city + ", "} {selectedAddress?.country}
                    </Typography>
                    <Typography>CEP: {selectedAddress?.postalCode}</Typography>
                    <Typography>{selectedAddress?.receiver}</Typography>
                  </>
                )}
              </Box>
            </Box>
          )}
          {loadingFretes ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography>Calculando fretes</Typography>
              <CircularProgress size={20} color="secondary" />
            </Box>
          ) : (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Typography
                  fontSize={25}
                  fontWeight={700}
                  color={colors.purple[500]}
                >
                  Fretes :
                </Typography>
                {selectedAddress ? (
                  <Box>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={selectedFrete?.freteType}
                        onChange={handleChangeFrete}
                      >
                        {freteInfo?.map((frete) => (
                          <FormControlLabel
                            value={frete?.name}
                            control={<Radio />}
                            label={
                              frete?.hasError
                                ? `${frete?.name} - Indisponível para o endereço selecionado`
                                : `${frete?.name} - R$ ${frete?.price} - ${frete?.timeDelivery} dia(s)`
                            }
                            disabled={frete?.hasError}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </Box>
                ) : (
                  <Typography>Selecione um endereço</Typography>
                )}
              </Box>
            </Box>
          )}

          <Box
            p={isMobile ? 1 : 3}
            gap={1}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
            width={isSmalldesktop ? "100%" : "auto"}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography
                fontSize={21}
                fontWeight={700}
                color={colors.purple[500]}
              >
                Quantidade de itens:
              </Typography>
              <Typography fontSize={21}>{totalItens}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography
                fontSize={25}
                fontWeight={700}
                color={colors.purple[500]}
              >
                Subtotal:
              </Typography>
              <Typography fontSize={21}>
                {BRLmoney(fullPrice + Number(selectedFrete.value) * 100)}
              </Typography>
            </Box>
            <Divider
              sx={{
                border: `1px solid ${colors.purple[500]}`,
                width: "300px",
                mt: 3,
                mb: 3,
              }}
            />
            <Box
              display={"flex"}
              flexWrap={"wrap"}
              alignItems={"center"}
              gap={1}
            >
              {showBackBTN && (
                <Button
                  onClick={backStep}
                  variant="contained"
                  fullWidth={isMobile ? true : false}
                  style={{ fontSize: isMobile ? 12 : 14 }}
                >
                  <ArrowBackIcon sx={{ mr: 1 }} /> Voltar ao carrinho
                </Button>
              )}
              <Button
                style={{ fontSize: isMobile ? 12 : 14 }}
                variant="contained"
                fullWidth={isMobile ? true : false}
                onClick={nextStep}
                disabled={!Boolean(selectedAddress) || disablePayButton}
                sx={{
                  background: teal[500],
                  "&:hover": { background: teal[200] },
                }}
              >
                {btnText}
              </Button>
            </Box>
          </Box>
        </Box>
        <CustomModal
          openModal={newAddressModalOpen}
          setOpenModal={setNewAddressModalOpen}
          width={isSmalldesktop ? "90%" : "50%"}
        >
          <EditCreateAddress
            userData={user}
            submitLoading={loadingNewAd}
            address={selectedAddress}
            handleSubmit={(val) => createEditAddress(val)}
            thisUserAlreadyHaveAddress={
              address && address?.length > 0 ? true : false
            }
          />
        </CustomModal>
      </FadeInContainer>
    )
  );
}
